import IconHandcash from "../components/ConnectWallet/assets/images/handcash-logo.png";

export default {
  handcash: { label: "HandCash", icon: IconHandcash },
};
